// extracted by mini-css-extract-plugin
module.exports = {"couponBar":"QK","error":"RK","disabled":"SK","toggleBtn":"TK","arrowDown":"UK","arrowUp":"VK","errorMsg":"WK"};